import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminBreadcrumbsService {
  private _linksData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor() { }

  updateBreadcrumbs(linksDetails: any[]) {
    this._linksData.next(linksDetails);
  }

  get getbreadcrumbs(): Observable<any[]> {
    return this._linksData.asObservable();
  }

  public allLinks: any = {
    // Marketplace: [
    //   { name: 'Rcs Pos', link: '/pos/home' },
    //   { name: 'Mocha Payments', link: 'demo' },
    //   { name: 'Production System', link: 'demo' },
    //   { name: 'Donation Management', link: '/admin/home/donation-managemnt' },
    //   { name: 'Consumer Mobile App', link: 'demo' },
    //   { name: 'Self Checkout', link: 'demo' },
    //   { name: 'Ticketing System (reservations)', link: 'demo' },
    //   { name: 'Ecommerce', link: 'demo' }
    // ],

    Dashboard: [
      { name: 'Employee Report', link: '/admin/home/emp-report' },
      { name: 'Production Overview', link: '/admin/home/overview' },
      { name: 'Top Performer', link: '/admin/home/top-performer' },
      { name: 'Sale Per Producer Report', link: '/admin/home/sale-per-producer-report' },
    ],

    StoreManagement: [
      { name: 'Stores', link: '/admin/home/stores' },
      { name: 'Stations', link: '/admin/home/stations' },
      { name: 'Store Groups', link: '/admin/home/store-groups' },
      { name: 'Store Types', link: '/admin/home/store-types' },
    ],

    CompanyConfig: [
      { name: 'API Users', link: '/admin/home/api-users' },
      { name: 'Brands', link: '/admin/home/brands' },
      { name: 'Categories', link: '/admin/home/categories' },
      { name: 'Departments', link: '/admin/home/departments' },
      { name: 'Goals', link: '/admin/home/goals' },
      { name: 'Goal Groups', link: '/admin/home/goals-groups' },
      { name: 'Labels', link: '/admin/home/labels' },
      { name: 'Pricing', link: '/admin/home/pricing/pricing-config' },
      { name: 'Quality & Conditions', link: '/admin/home/grades' },
      { name: 'Sizes', link: '/admin/home/sizing' },
      { name: 'Week Colors', link: '/admin/home/week-colors' },
    ],

    CompanyManagement: [
      { name: 'API Users', link: '/admin/home/api-users' },
      { name: 'Labels', link: '/admin/home/labels' }
    ],

    InventoryManagement: [
      { name: 'Counting', link: '/admin/home/counting' },
      { name: 'Movement', link: '/admin/home/movement' },
      { name: 'Transfer', link: '/admin/home/transfer' },
      { name: 'Item on Hand', link: '/admin/home/onhands' }
    ],

    UserManagement: [
      { name: 'Users', link: '/admin/home/users' },
      { name: 'Access Roles', link: '/admin/home/roles' },
    ],
  }
}
